(function () {
  var root = document.querySelector('[data-omni-quiz]');
  if (!root) return;

  /* ============================================================
   * QUIZ COPY & SCORING - Quiz Vol. 3.4 - Weight Loss
   * Everything a copy change touches lives in this object.
   * ============================================================ */
  var QUIZ = {
    id: 'vol3_4_weight_loss',
    name: 'Quiz Vol. 3.4 - Weight Loss',

    /* score >= thresholds[0] -> results[0], >= thresholds[1] -> results[1], else results[2] */
    thresholds: [16, 10],
    max: 27,
    /* displayed % range per tier, interpolated by score */
    display: [[14, 28], [38, 52], [60, 74]],
    /* inverse:true -> high score lights up the LEFT side of the meter */
    inverse: true,

    hero: {
      h: 'Find out how much weight you can lose in 90 days - with and without creatine',
      sub: 'This 2-minute assessment analyzes your metabolism, habits and muscle profile to project your realistic 90-day result - and what’s been holding it back.',
      quote: 'Down 19 lbs in 10 weeks and I didn’t lose my shape. First thing that actually worked.',
      name: 'Sarah'
    },

    screens: [
      {
        q: 'How much weight do you want to lose?',
        opts: ['Over 50 lbs', '25-50 lbs', '10-25 lbs', 'Under 10 lbs'],
        pts: [3, 2, 1, 0]
      },
      {
        q: 'What best describes you?',
        opts: ['Female', 'Male'],
        pts: [1, 0],
        segment: 'sex',
        segmentValues: ['female', 'male'],
        note: 'Fat loss and muscle retention differ by biological sex. We tailor your projection accordingly.'
      },
      {
        q: 'What’s stopped you before?',
        opts: ['Plateaus - the scale stops moving', 'Cravings and low energy', 'Losing weight but looking soft', 'Gaining it all back', 'Never stuck with it long enough'],
        pts: [3, 2, 2, 3, 2]
      },
      {
        q: 'Have you lost weight before and then regained it?',
        opts: ['Yes', 'No'],
        pts: [3, 0]
      },
      {
        q: 'How’s your energy at 3pm compared to when you wake up?',
        opts: ['Completely drained - need caffeine or a nap', 'Noticeably lower - afternoon slump hits hard', 'Slightly tired - still functional but slower', 'Same energy - no afternoon crash'],
        pts: [3, 2, 1, 0]
      },
      {
        q: 'When did the weight start creeping on?',
        opts: ['Over a year ago', 'In the past year', 'In the past few months', 'It’s always been a struggle'],
        pts: [2, 2, 1, 3]
      },
      {
        q: 'What result matters most to you?',
        opts: ['Smaller waist and flatter stomach', 'Toned - not just smaller', 'Keeping it off for good', 'Energy to stay consistent', 'All of the above'],
        pts: [0, 0, 0, 0, 0]
      },
      {
        proof: true,
        sub: 'Over 100,000+ people have used creatine to lose fat while keeping muscle - the difference between "smaller" and "toned".',
        t: [
          ['Lost 23 lbs and for the first time I look athletic instead of just thinner.', 'Jessica, 34'],
          ['My plateau broke in 2 weeks. I’d been stuck for 5 months.', 'Amanda, 28']
        ]
      },
      {
        q: 'How would you describe your current body composition?',
        opts: ['Lean and toned', 'Average build', 'Soft with some muscle', 'Out of shape / low muscle tone'],
        pts: [0, 1, 2, 3]
      },
      {
        q: 'How many hours of quality sleep do you get per night?',
        opts: ['Less than 5 hours', '5-6 hours', '7-8 hours', 'More than 8 hours'],
        pts: [3, 2, 1, 0]
      },
      {
        q: 'Do you have a family history of weight gain, diabetes, or metabolic issues?',
        sub: 'Genetics set the baseline - muscle sets the ceiling.',
        opts: ['Yes', 'No', 'Not sure'],
        pts: [2, 0, 1],
        why: 'Muscle is your metabolic engine - every pound burns calories 24/7. Creatine builds and protects that muscle so your metabolism rises on a diet instead of crashing.'
      },
      { l1: 'Our algorithm is cross-referencing your profile with body-composition data from 500+ clinical studies.' },
      {
        q: 'How often do you eat red meat or fish?',
        sub: '(These are the primary natural sources of creatine)',
        opts: ['Daily - most meals include meat/fish', 'Several times a week', 'Occasionally - mostly plant-based', 'Rarely/never - vegetarian or vegan'],
        pts: [0, 1, 2, 3],
        why: 'Red meat and fish are the primary dietary sources of creatine - and the first things people cut when dieting. Low intake means muscle loss, a slower metabolism and the inevitable plateau.'
      },
      {
        l2: [
          'Personalizing your 90-day projection',
          ['Analyzing metabolic profile', 'Cross-checking your reported symptoms'],
          ['Cross-referencing lifestyle factors', 'Diet, sleep, and activity patterns'],
          ['Calibrating your protocol', 'Matching to clinical benchmarks'],
          ['Personalizing your result', 'Generating your projection...']
        ]
      }
    ],

    /* email_gate test - shown on the last "Building your profile" step, before results */
    gate: {
      sub: 'Enter your email to see your creatine level and personal 90-day projection.'
    },

    meter: {
      eyebrow: 'YOUR WEIGHT-LOSS PROJECTION',
      label: 'Your Fat-Loss Potential',
      scale: ['STALLED', 'MID', 'STEADY', 'RAPID'],
      prefix: 'Your status:',
      reverse: false
    },

    proj: {
      eyebrow: 'WITH VS. WITHOUT CREATINE',
      title: '90-Day Fat-Loss Projection',
      sub: 'Based on your unique assessment profile',
      axis: ['Goal', 'On track', 'Slow', 'Stalled'],
      you: 'Your progress',
      compare: true,
      withoutDown: false
    },

    results: [
      {
        tier: 'high',
        level: 'STALLED',
        status: 'METABOLISM UNDER-FUELED',
        desc: 'Your body is primed to burn muscle, not fat. That’s why diets stall and the weight comes back.',
        st: [['STATUS', 'STALLED', 'METABOLISM'], ['90-DAY OUTLOOK', '2X', 'MORE WITH CREATINE'], ['POTENTIAL', '+65%', 'MORE FAT LOSS']],
        intro: 'Low muscle creatine means low energy, weak workouts and a slowing metabolism. This directly affects:',
        b: ['How much of the weight you lose is fat vs. muscle', 'Calories burned at rest', 'Cravings and afternoon crashes', 'Whether the weight stays off'],
        close: '<strong>The good news:</strong> creatine + resistance training cut body-fat percentage significantly more than training alone across 19 trials (Forbes et al., 2019) - and the most under-fueled respond most.',
        cta: 'SHOW ME MY 90-DAY PROJECTION',
        gain: '+65%',
        ms: [
          ['Week 1-2', 'Energy Phase', 'Cellular energy restored. Cravings drop, workouts get stronger.'],
          ['Week 3-6', 'Fat-Burn Phase', 'Muscle retained, fat mobilized. Waist measurements move first.'],
          ['Month 2-3', 'Recomposition', 'Visible toning. Metabolism higher than when you started.']
        ]
      },
      {
        tier: 'high',
        level: 'SLOW',
        status: 'PLATEAU RISK',
        desc: 'You’ll lose weight - but you’re on track to lose muscle with it and stall around week 6.',
        st: [['STATUS', 'SLOW', 'METABOLISM'], ['90-DAY OUTLOOK', '+40%', 'MORE WITH CREATINE'], ['POTENTIAL', '+40%', 'MORE FAT LOSS']],
        intro: 'Your body is partially fueled but can’t sustain the deficit. You may be noticing:',
        b: ['The first 2 weeks go well, then it stops', 'Looking "smaller" but not firmer', 'Energy crashes derail consistency', 'Weight creeps back on weekends'],
        close: 'Creatine keeps strength and muscle up through a deficit, so the scale keeps moving - and what you lose is fat.',
        cta: 'SHOW ME MY 90-DAY PROJECTION',
        gain: '+40%',
        ms: [
          ['Week 1-2', 'Loading Phase', 'Stores refill. Energy and training quality rise.'],
          ['Week 3-6', 'Plateau-Proof', 'Muscle preserved. Fat loss continues past the usual stall.'],
          ['Month 2-3', 'Toned Result', 'Firmer body, higher resting metabolism.']
        ]
      },
      {
        tier: 'medium',
        level: 'STEADY',
        status: 'ON TRACK - ROOM TO OPTIMIZE',
        desc: 'Your habits are solid. Creatine makes the same effort produce more fat loss.',
        st: [['STATUS', 'STEADY', 'METABOLISM'], ['90-DAY OUTLOOK', '+25%', 'MORE WITH CREATINE'], ['POTENTIAL', '+25%', 'MORE FAT LOSS']],
        intro: 'You’re already losing. Full creatine saturation adds:',
        b: ['More muscle kept = more calories burned', 'Better workouts in a deficit', 'Firmer, more athletic end result', 'Easier maintenance afterwards'],
        close: 'Even well-trained dieters retain significantly more lean mass with creatine vs. placebo - meaning a higher metabolism at goal weight.',
        cta: 'SHOW ME MY 90-DAY PROJECTION',
        gain: '+25%',
        ms: [
          ['Week 1-2', 'Top-Off', 'Stores reach capacity. Slight energy boost.'],
          ['Week 3-6', 'Acceleration', 'Fat-loss rate increases while strength holds.'],
          ['Month 2-3', 'Goal Weight', 'Arrive lean, strong - and able to keep it off.']
        ]
      }
    ]
  };

  /* ============================================================
   * ENGINE - shared logic. Copy above this line is quiz-specific.
   * ============================================================ */

  var REDIRECT_URL = root.getAttribute('data-redirect-url') || '/pages/quiz-pdp';
  var ADVANCE_DELAY = 230;

  var SEG_COLORS = ['#D42929', '#EA4949', '#F49F13', '#239627'];
  var ACCENT = { high: '#EA4949', medium: '#F49F13', low: '#39CA3E' };

  var ARROW_IMG = '<img src="' + (root.getAttribute('data-arrow-icon') || '') + '" alt="">';

  var FDA_NOTE = '<p class="oq-disclaimer oq-fade-up oq-d7">These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure, or prevent any disease.</p>';

  var GAUGE_NOTE = '<p class="oq-gauge-note">Estimate from your diet answer. Not a measurement.</p>';
  var VERIFIED_IMG = '<span class="oq-vicon"><img src="' + (root.getAttribute('data-verified-icon') || '') + '" alt=""></span>';
  var BADGE_CHECK_IMG = '<img src="' + (root.getAttribute('data-check-icon') || '') + '" alt="">';
  var LIGHTNING_SVG = '<svg viewBox="0 0 18 18" fill="none"><path d="M10 1.5L3.5 10.5h4.5l-1 6 6.5-9h-4.5l1-6z" fill="currentColor"/></svg>';

  var state = { screen: 0, answers: {}, answerText: {}, score: 0, tier: 0, started: false };

  /* ---- screen index map ------------------------------------ */
  var STEPS = QUIZ.screens;
  var IDX_RESULT = STEPS.length;
  var IDX_PROJECTION = STEPS.length + 1;
  var IDX_FINAL = STEPS.length + 2;
  var TOTAL = STEPS.length + 3;

  var QUESTION_KEYS = [];
  var SCREEN_IDS = [];
  (function () {
    var qn = 0;
    STEPS.forEach(function (sc, i) {
      if (sc.proof) { SCREEN_IDS.push('social_proof'); QUESTION_KEYS.push(null); return; }
      if (sc.l1) { SCREEN_IDS.push('analyzing'); QUESTION_KEYS.push(null); return; }
      if (sc.l2) { SCREEN_IDS.push('building_profile'); QUESTION_KEYS.push(null); return; }
      qn++;
      QUESTION_KEYS.push('question_' + qn);
      SCREEN_IDS.push('question_' + qn);
    });
    SCREEN_IDS.push('results', 'projection', 'final_loader');
  })();

  var NO_PROGRESS = {};
  STEPS.forEach(function (sc, i) { if (sc.l1 || sc.l2) NO_PROGRESS[i] = 1; });
  NO_PROGRESS[IDX_RESULT] = 1;
  NO_PROGRESS[IDX_PROJECTION] = 1;
  NO_PROGRESS[IDX_FINAL] = 1;

  /* ---- Intelligems tests (assets/omni-quiz-ig-test.js) ---------- */
  /* Only experiences that are active in Intelligems run, at most one per visitor.
     quizArm / quizFeature / quizKey are set once Intelligems places the visitor;
     outside a test they stay null and the quiz runs exactly as before. What
     each variant (metaobject attribute_key) changes:
       no_middle  - skips the middle screens and, after the last question, goes
                    straight to REDIRECT_URL (no results, projection, final loader)
       email_gate - the "Building your profile" loader stops on its last step and
                    asks for an email before the results
       left_align - left-aligned layout (.oq-t-left-align, omni-quiz-vol3.css)
       navigation - back arrow + "3 / 11" counter in the header (.oq-t-nav)
     left_align / navigation change the first screen, so they are decided on page
     load (the quiz stays hidden for up to SL_WAIT_MS); the others on the first
     answer. ?oqv=<feature> previews a variant without Intelligems (untracked). */
  var LOAD_FEATURES = { left_align: 1, navigation: 1 };
  var SL_WAIT_MS = 2000;
  var slTest = null;
  var quizArm = null;
  var quizFeature = null;
  var quizKey = null;
  var armPreview = false;
  var rolloutArm = null;
  var completed = false;
  var leaving = false;

  function variantIs(feature) {
    return quizArm === 'variant' && quizFeature === feature;
  }

  function skipsScreen(i) {
    var sc = STEPS[i];
    return variantIs('no_middle') && !!sc && !!(sc.proof || sc.l1 || sc.l2);
  }

  function startQuizTest(onSettled) {
    var test = slTest;
    slTest = null;
    if (!test || quizArm) {
      if (onSettled) onSettled();
      return;
    }
    window.omniQuizTest.assign(root, test).then(function (res) {
      if (res && !quizArm) {
        quizArm = res.arm;
        quizFeature = res.feature;
        quizKey = res.key;
        if (quizArm === 'variant') applyVariant();
        track('quiz_test_assigned', {});
      }
      if (onSettled) onSettled();
    });
  }

  function applyVariant() {
    if (quizFeature === 'left_align') root.classList.add('oq-t-left-align');
    if (quizFeature === 'navigation') setupNav();
    var fill = root.querySelector('[data-oq-progress]');
    if (fill) fill.style.width = progressFor(state.screen) + '%';
    syncNav();
  }

  /* navigation: question number per screen (non-question screens keep the last one) */
  var TOTAL_Q = 0;
  var QNUM = SCREEN_IDS.map(function (id) {
    if (/^question_\d+$/.test(id)) TOTAL_Q++;
    return TOTAL_Q;
  });
  var advanceTimer = null;

  /* header markup for the navigation variant - built here so the control's DOM is untouched */
  function setupNav() {
    root.classList.add('oq-t-nav');
    var header = root.querySelector('.oq-header');
    var logo = header && header.querySelector('.oq-logo');
    if (!logo || root.querySelector('.oq-topbar')) return;
    var bar = document.createElement('div');
    bar.className = 'oq-topbar';
    bar.innerHTML = '<button type="button" class="oq-back is-hidden" data-oq-back aria-label="Go back">' +
      '<img src="' + esc(root.getAttribute('data-back-icon') || '') + '" alt="" width="32" height="32"></button>';
    header.insertBefore(bar, logo);
    bar.appendChild(logo);
    var counter = document.createElement('span');
    counter.className = 'oq-counter';
    counter.setAttribute('data-oq-counter', '');
    counter.setAttribute('aria-hidden', 'true');
    bar.appendChild(counter);
    if (!document.querySelector('link[data-oq-nav-font]')) {
      var font = document.createElement('link');
      font.rel = 'stylesheet';
      font.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,800&display=swap';
      font.setAttribute('data-oq-nav-font', '');
      document.head.appendChild(font);
    }
  }

  function syncNav() {
    if (!variantIs('navigation')) return;
    var back = root.querySelector('[data-oq-back]');
    var counter = root.querySelector('[data-oq-counter]');
    var hide = !!NO_PROGRESS[state.screen];
    if (back) back.classList.toggle('is-hidden', hide || state.screen === 0);
    if (counter) {
      counter.classList.toggle('is-hidden', hide);
      counter.textContent = hide ? '' : QNUM[state.screen] + ' / ' + TOTAL_Q;
    }
  }

  /* back arrow skips auto-advancing loader screens */
  function prevScreen(idx) {
    var i = idx - 1;
    while (i > 0 && NO_PROGRESS[i]) i--;
    return i;
  }

  /* email gate copy + Klaviyo (email_gate variant only) */
  var KLAVIYO_COMPANY = root.getAttribute('data-klaviyo-company') || 'UyXd2p';
  var KLAVIYO_LIST = root.getAttribute('data-klaviyo-list') || '';
  var KLAVIYO_REVISION = '2024-10-15';
  var PRIVACY_URL = root.getAttribute('data-privacy-url') || '/policies/privacy-policy';
  var GATE = {
    eyebrow: 'PROFILE COMPLETE',
    h: 'Your results are ready.',
    sub: 'Enter your email to see your creatine level and personal timeline.',
    lock: 'UNLOCKS WITH YOUR EMAIL',
    placeholder: 'Your email address',
    cta: 'SEE MY RESULTS',
    legal: 'We\'ll also email you a copy + your 47% off code. No spam, unsubscribe anytime.',
    invalid: 'Please enter a valid email address.'
  };
  Object.keys(QUIZ.gate || {}).forEach(function (k) { GATE[k] = QUIZ.gate[k]; });
  var gateState = { open: false, email: '', resumeStep: 0 };

  /* ---- scoring --------------------------------------------- */
  function calcScore() {
    var s = 0;
    STEPS.forEach(function (sc, i) {
      if (!sc.pts) return;
      var a = state.answers[i];
      if (a !== undefined && sc.pts[a] !== undefined) s += sc.pts[a];
    });
    state.score = s;
    var th = QUIZ.thresholds;
    state.tier = s >= th[0] ? 0 : s >= th[1] ? 1 : 2;
  }

  function displayPct() {
    var t = state.tier;
    var range = QUIZ.display[t];
    var lo = range[0], hi = range[1];
    var th = QUIZ.thresholds;
    var bounds = t === 0 ? [th[0], QUIZ.max] : t === 1 ? [th[1], th[0] - 1] : [0, th[1] - 1];
    var tmin = bounds[0], tmax = bounds[1];
    var f = tmax > tmin ? (state.score - tmin) / (tmax - tmin) : 0.5;
    f = Math.max(0, Math.min(1, f));
    return Math.round(QUIZ.inverse ? hi - f * (hi - lo) : lo + f * (hi - lo));
  }

  function result() { return QUIZ.results[state.tier]; }
  function tierName() { return result().tier; }
  function tierClass() { return 'oq-tier--' + tierName(); }
  function accentColor() { return ACCENT[tierName()]; }
  function activeSegment() { return QUIZ.inverse ? state.tier : 3 - state.tier; }
  function segColors() { return QUIZ.meter.reverse ? SEG_COLORS.slice().reverse() : SEG_COLORS.slice(); }

  /* ---- segmentation ---------------------------------------- */
  function segmentParams() {
    var out = {};
    STEPS.forEach(function (sc, i) {
      if (!sc.segment) return;
      var a = state.answers[i];
      if (a === undefined) return;
      out[sc.segment] = (sc.segmentValues && sc.segmentValues[a]) || String(a);
    });
    return out;
  }

  /* ---- analytics ------------------------------------------- */
  function answerList() {
    var out = [];
    STEPS.forEach(function (sc, i) {
      if (!QUESTION_KEYS[i] || state.answerText[i] === undefined) return;
      out.push({
        id: QUESTION_KEYS[i],
        question: sc.q,
        answer: state.answerText[i],
        points: sc.pts ? sc.pts[state.answers[i]] : 0
      });
    });
    return out;
  }

  function quizPayload() {
    var payload = {
      quiz_id: QUIZ.id,
      quiz_name: QUIZ.name,
      score: state.score,
      max: QUIZ.max,
      tier: tierName(),
      result: 'R' + (state.tier + 1),
      level: result().level,
      display_pct: displayPct(),
      answers: answerList()
    };
    var seg = segmentParams();
    Object.keys(seg).forEach(function (k) { payload[k] = seg[k]; });
    return payload;
  }

  function klaviyoProps() {
    var kl = QUIZ.klaviyo || {};
    var props = quizPayload();
    props.quiz_source = kl.source || QUIZ.name;
    props.quiz_variant = QUIZ.id;
    /* legacy aliases - keep old segments/flows working */
    props.quiz_score = state.score;
    props.quiz_tier = tierName();
    /* flat per-question props too - Klaviyo cannot segment on arrays */
    QUESTION_KEYS.forEach(function (key, i) {
      if (key && state.answerText[i]) props['quiz_' + key.replace('question_', 'q')] = state.answerText[i];
    });
    var ro = typeof window.omniRollout === 'function' ? window.omniRollout() : null;
    if (ro && ro.exposed) props.quiz_rollout = ro.label;
    return props;
  }

  function sendToKlaviyo() {
    if (!window.klaviyo || typeof window.klaviyo.push !== 'function') return;
    var kl = QUIZ.klaviyo || {};
    var props = klaviyoProps();
    try {
      window.klaviyo.push(['identify', props]);
      window.klaviyo.push(['track', kl.event || (QUIZ.name + ' Completed'), props]);
    } catch (e) {}
  }

  function klaviyoPost(endpoint, payload) {
    return fetch('https://a.klaviyo.com/client/' + endpoint + '/?company_id=' + encodeURIComponent(KLAVIYO_COMPANY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISION },
      body: JSON.stringify(payload)
    });
  }

  /* email_gate variant: the "Completed" event goes out with the email (client API)
     instead of the anonymous onsite push. Never rejects - a Klaviyo failure must
     not leave anyone stuck behind the gate. */
  function sendGateToKlaviyo(email) {
    var kl = QUIZ.klaviyo || {};
    var props = klaviyoProps();
    var profileProps = {};
    Object.keys(props).forEach(function (k) { if (k !== 'answers') profileProps[k] = props[k]; });

    /* onsite identify - ties this browser's later events (viewed product, cart) to the email */
    try {
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        var idProps = { $email: email };
        Object.keys(profileProps).forEach(function (k) { idProps[k] = profileProps[k]; });
        window.klaviyo.push(['identify', idProps]);
      }
    } catch (e) {}

    if (!KLAVIYO_COMPANY || typeof fetch !== 'function') return Promise.resolve({});

    var profile = { data: { type: 'profile', attributes: { email: email, properties: profileProps } } };
    var event = klaviyoPost('events', {
      data: {
        type: 'event',
        attributes: {
          properties: props,
          metric: { data: { type: 'metric', attributes: { name: kl.event || (QUIZ.name + ' Completed') } } },
          profile: profile
        }
      }
    });
    var subscribe = KLAVIYO_LIST ? klaviyoPost('subscriptions', {
      data: {
        type: 'subscription',
        attributes: { custom_source: props.quiz_source, profile: { data: { type: 'profile', attributes: { email: email, properties: profileProps } } } },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
      }
    }) : Promise.resolve(null);

    return Promise.all([event, subscribe]).then(function (res) {
      res.forEach(function (r) {
        if (r && !r.ok) console.warn('[quiz] Klaviyo ' + r.url.split('/client/')[1].split('/')[0] + ' failed: ' + r.status);
      });
    }, function (err) { console.warn('[quiz] Klaviyo request failed', err); });
  }

  var dlQueue = [];
  var dlTimer = null;
  var dlTicks = 0;

  function gtagArgs() { return arguments; }

  function gaConfigured() {
    var dl = window.dataLayer;
    if (!dl) return false;
    for (var i = 0; i < dl.length; i++) {
      if (dl[i] && dl[i][0] === 'config') return true;
    }
    return false;
  }

  function pushDataLayer(args) {
    window.dataLayer = window.dataLayer || [];
    if (gaConfigured()) {
      window.dataLayer.push(args);
      return;
    }
    dlQueue.push(args);
    if (dlTimer) return;
    dlTimer = setInterval(function () {
      dlTicks++;
      if (!gaConfigured()) {
        if (dlTicks < 150) return;
        clearInterval(dlTimer);
        dlTimer = null;
        dlQueue.length = 0;
        return;
      }
      clearInterval(dlTimer);
      dlTimer = null;
      while (dlQueue.length) window.dataLayer.push(dlQueue.shift());
    }, 200);
  }

  var lastStepAt = null;

  function track(eventName, params) {
    if (quizArm && !armPreview && !rolloutArm) {
      params = params || {};
      params.quiz_version = quizKey + ':' + quizArm;
    }
    if (rolloutArm && typeof window.omniRollout === 'function') {
      var ro = window.omniRollout();
      if (ro && ro.exposed) {
        params = params || {};
        params.quiz_rollout = ro.label;
      }
    }
    if (typeof window.omniTrack === 'function') {
      window.omniTrack(eventName, params);
      return;
    }
    var payload = params || {};
    payload.quiz_variant = QUIZ.id;
    var plain = {};
    Object.keys(payload).forEach(function (key) {
      if (typeof payload[key] !== 'function') plain[key] = payload[key];
    });
    try {
      pushDataLayer(gtagArgs('event', eventName, payload));
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, plain);
      }
      if (typeof window.clarity === 'function') {
        window.clarity('event', eventName);
        Object.keys(plain).forEach(function (key) {
          window.clarity('set', eventName + '_' + key, String(plain[key]));
        });
      }
    } catch (e) {}
  }

  /* ---- debug deep-links ------------------------------------ */
  var qsp = new URLSearchParams(window.location.search);
  if (qsp.get('oqs') !== null) state.screen = Math.min(TOTAL - 1, parseInt(qsp.get('oqs'), 10) || 0);
  /* ?oqv=<feature> shows that test variant without Intelligems: nothing is tracked as a
     test arm. oqv=variant is kept as an alias of no_middle. */
  var oqv = qsp.get('oqv') === 'variant' ? 'no_middle' : qsp.get('oqv');
  if ({ no_middle: 1, email_gate: 1, left_align: 1, navigation: 1 }[oqv]) {
    slTest = null;
    quizArm = 'variant';
    quizFeature = oqv;
    armPreview = true;
    applyVariant();
  }
  if (qsp.get('oqt') !== null) {
    var raw = qsp.get('oqt');
    var forced = { '0': 0, '1': 1, '2': 2, r1: 0, r2: 1, r3: 2, high: 0, medium: 1, low: 2 }[raw];
    if (forced !== undefined) {
      var th = QUIZ.thresholds;
      state.score = forced === 0 ? th[0] + 2 : forced === 1 ? Math.round((th[0] + th[1]) / 2) : Math.round(th[1] / 2);
      state.tier = forced;
      state.forcedTier = true;
    }
  }

  /* ---- html helpers ---------------------------------------- */
  function esc(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function optionsHtml(screenIndex, options) {
    return '<div class="oq-options">' + options.map(function (o, i) {
      return '<button type="button" class="oq-option" data-s="' + screenIndex + '" data-i="' + i + '">' + esc(o) + '</button>';
    }).join('') + '</div>';
  }

  function testimonialCard(text, initial, name, extraClass) {
    return '<div class="oq-card oq-testimonial ' + (extraClass || '') + '">' +
      '<p class="oq-testimonial-text">"' + esc(text) + '"</p>' +
      '<div class="oq-testimonial-meta">' +
      '<span class="oq-avatar">' + esc(initial) + '</span>' +
      '<span class="oq-testimonial-name">' + esc(name) + '</span>' +
      '<span class="oq-verified">' + VERIFIED_IMG + 'Verified buyer</span>' +
      '</div></div>';
  }

  function whyBox(text) {
    return '<div class="oq-card oq-why"><p class="oq-why-label">WHY WE ASK</p><p class="oq-why-text">' + esc(text) + '</p></div>';
  }

  function centered(inner, cls) {
    return '<div class="' + cls + '" style="width:100%;display:flex;justify-content:center;">' + inner + '</div>';
  }

  function stepCard(step, iconState, numbered) {
    var icon;
    if (iconState === 'done') icon = '<div class="oq-step-icon">' + BADGE_CHECK_IMG + '</div>';
    else if (iconState === 'active') icon = '<div class="oq-step-icon"><div class="oq-step-spinner"></div></div>';
    else if (numbered) icon = '<div class="oq-step-num">' + step.num + '</div>';
    else icon = '<div class="oq-step-num"></div>';
    return '<div class="oq-step" data-step>' + icon +
      '<div class="oq-step-text"><h4>' + esc(step.title) + '</h4><p>' + esc(step.text) + '</p></div></div>';
  }

  function loaderSteps() {
    var def = null;
    STEPS.forEach(function (sc) { if (sc.l2) def = sc.l2; });
    var rows = def.slice(1);
    return rows.map(function (r, i) { return { num: i + 1, title: r[0], text: r[1] }; });
  }

  function loaderTitle() {
    var def = null;
    STEPS.forEach(function (sc) { if (sc.l2) def = sc.l2; });
    return def[0];
  }

  function finalSteps() {
    var s = loaderSteps().map(function (x) { return { num: x.num, title: x.title, text: x.text }; });
    s[s.length - 1] = { num: s.length, title: 'Generating your link', text: 'Creating secure checkout...' };
    return s;
  }

  /* ---- ring ------------------------------------------------ */
  var RING_R = 94;

  function ringValueHtml(v) {
    var s = String(v);
    if (s.charAt(s.length - 1) === '%') return esc(s.slice(0, -1)) + '<span class="oq-ring-pct">%</span>';
    return esc(s);
  }

  function ringHtml(centerValue, centerLabel) {
    var c = 2 * Math.PI * RING_R;
    return '<div class="oq-ring-wrap">' +
      '<svg class="oq-ring-svg" viewBox="0 0 200 200">' +
      '<defs><linearGradient id="oqRingGrad" x1="0" y1="0" x2="1" y2="1">' +
      '<stop offset="0%" stop-color="#96B4D4"/>' +
      '<stop offset="100%" stop-color="#33517D"/>' +
      '</linearGradient></defs>' +
      '<circle class="oq-ring-disc" cx="100" cy="100" r="76"/>' +
      '<circle class="oq-ring-track" cx="100" cy="100" r="' + RING_R + '"/>' +
      '<circle class="oq-ring-fg" cx="100" cy="100" r="' + RING_R + '" stroke-dasharray="' + c + '" stroke-dashoffset="' + c + '" data-ring/>' +
      '</svg>' +
      '<div class="oq-ring-center"><span class="oq-ring-value" data-ring-value>' + ringValueHtml(centerValue) + '</span>' +
      (centerLabel ? '<span class="oq-ring-label">' + esc(centerLabel) + '</span>' : '') +
      '</div></div>';
  }

  /* ---- meter ----------------------------------------------- */
  function gaugeHtml() {
    var m = QUIZ.meter;
    var colors = segColors();
    var active = activeSegment();
    var needle = '<div class="oq-gauge-needle"><img src="' + (root.getAttribute('data-needle-icon') || '') + '" alt=""></div>';
    return '<div class="oq-rescard oq-gauge-card">' +
      '<div><p class="oq-gauge-title">' + esc(m.label) + '</p>' +
      '<div class="oq-gauge-cols">' + m.scale.map(function (l, i) {
        var isActive = i === active;
        return '<div class="oq-gauge-col' + (isActive ? ' is-active' : '') + '">' +
          '<div class="oq-gauge-col-top">' + (isActive ? needle : '') +
          '<div class="oq-gauge-seg oq-gauge-seg--s' + i + '" style="background:' + colors[i] + '"></div></div>' +
          '<span>' + esc(l) + '</span></div>';
      }).join('') + '</div></div>' +
      '<div class="oq-gauge-foot">' +
      '<p class="oq-gauge-level">' + esc(m.prefix) + ' <strong class="oq-tier-accent">' + esc(result().level) + '</strong></p>' +
      '<span class="oq-pct-pill oq-tier-accent">' + displayPct() + '%</span>' +
      '</div>' + GAUGE_NOTE + '</div>';
  }

  /* ---- projection chart ------------------------------------ */
  function chartHtml() {
    var pj = QUIZ.proj;
    var r = result();
    var t = state.tier;
    var mob = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    var W = mob ? 303 : 582, H = mob ? 196 : 275, padL = mob ? 68 : 88, padT = mob ? 10 : 15, padB = mob ? 33 : 39;
    var plotW = W - padL, plotH = H - padT - padB;
    var yLabels = pj.axis;
    var xLabels = ['Now', '30 days', '60 days', '90 days'];
    var rows = 4;
    var chartStartY = [3, 2, 1][t];
    var yFor = function (level) { return padT + (level / (rows - 1)) * plotH; };
    var startY = yFor(chartStartY) - 6;
    var endY = mob ? padT + 11 : padT;
    var startX = mob ? padL + plotW * 0.03 : padL + 6;
    var endX = mob ? padL + plotW - 4 : W;
    var midX = (startX + endX) / 2;
    var path = 'M ' + startX + ' ' + startY + ' C ' + midX + ' ' + startY + ', ' + midX + ' ' + endY + ', ' + endX + ' ' + endY;
    var areaPath = 'M ' + padL + ' ' + startY + ' L ' + startX + ' ' + startY + ' C ' + midX + ' ' + startY + ', ' + midX + ' ' + endY + ', ' + endX + ' ' + endY + ' L ' + W + ' ' + endY + ' L ' + W + ' ' + (H - padB) + ' L ' + padL + ' ' + (H - padB) + ' Z';

    var ghost = '';
    var legend = '';
    if (pj.compare) {
      var ghostEndY = pj.withoutDown
        ? Math.min(startY + plotH * 0.28, H - padB - 6)
        : startY - (startY - endY) * 0.32;
      var ghostPath = 'M ' + startX + ' ' + startY + ' C ' + midX + ' ' + (startY + (pj.withoutDown ? 4 : -6)) + ', ' + midX + ' ' + ghostEndY + ', ' + endX + ' ' + ghostEndY;
      ghost = '<path class="oq-chart-ghost" d="' + ghostPath + '"/>' +
        '<circle class="oq-chart-pin oq-chart-pin--ghost" cx="' + endX + '" cy="' + ghostEndY + '" r="5.5" fill="#0D1E39" stroke="rgba(255,255,255,0.45)" stroke-width="3"/>';
      legend = '<div class="oq-chart-legend">' +
        '<span><i class="oq-legend-solid"></i>With creatine</span>' +
        '<span><i class="oq-legend-dash"></i>Without</span>' +
        '</div>';
    }

    var grid = '';
    var labels = '';
    for (var i = 0; i < rows; i++) {
      var gy = yFor(i);
      grid += '<line class="oq-chart-grid-line" style="animation-delay:' + (250 + i * 80) + 'ms" x1="' + padL + '" y1="' + gy + '" x2="' + W + '" y2="' + gy + '"/>';
      labels += '<text class="oq-chart-label" style="animation-delay:' + (600 + i * 60) + 'ms" x="0" y="' + (gy + 5) + '" text-anchor="start">' + esc(yLabels[i]) + '</text>';
    }
    var xw = mob ? [32, 51, 51, 51] : [41, 65, 65, 65];
    var xgap = (plotW - (xw[0] + xw[1] + xw[2] + xw[3])) / 3;
    var xpos = padL;
    for (var j = 0; j < xLabels.length; j++) {
      var gx = j === 0 ? padL : j === xLabels.length - 1 ? W : xpos + xw[j] / 2;
      labels += '<text class="oq-chart-label" style="animation-delay:' + (500 + j * 60) + 'ms" x="' + gx + '" y="' + (H - padB + (mob ? 27 : 32)) + '" text-anchor="' + (j === 0 ? 'start' : j === xLabels.length - 1 ? 'end' : 'middle') + '">' + xLabels[j] + '</text>';
      xpos += xw[j] + xgap;
    }
    var calloutH = mob ? 32 : 35;
    var calloutX = mob ? Math.max(padL - 8, startX - 14) : padL - 6;
    var calloutY = startY - calloutH - (mob ? 8 : 16);
    var badgeW = mob ? 70 : 76, badgeH = mob ? 25 : 33;
    var badgeX = W + (mob ? 28 : 32) - badgeW;
    var badgeY = endY - badgeH - 18;
    var levelColor = accentColor();
    var calloutBg = { high: 'rgba(212, 41, 41, 0.16)', medium: 'rgba(244, 158, 12, 0.16)', low: 'rgba(35, 150, 39, 0.16)' }[tierName()];
    var calloutHtml = '<div class="oq-chart-callout oq-chart-yourlevel" style="left:' + (calloutX / W * 100).toFixed(2) + '%;top:' + (calloutY / H * 100).toFixed(2) + '%;background:' + calloutBg + ';color:' + levelColor + '">' + esc(pj.you) + '</div>';

    return '<div class="oq-rescard oq-chart-card"><div class="oq-chart-box"><svg class="oq-chart-svg" viewBox="0 0 ' + W + ' ' + H + '">' +
      '<defs><linearGradient id="oqArea" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0%" stop-color="#A8C4E5" stop-opacity="0.45"/>' +
      '<stop offset="100%" stop-color="#A8C4E5" stop-opacity="0.03"/>' +
      '</linearGradient>' +
      '<linearGradient id="oqTrace" x1="0" y1="0" x2="1" y2="0">' +
      '<stop offset="0%" stop-color="#A8C4E5" stop-opacity="0.35"/>' +
      '<stop offset="55%" stop-color="#A8C4E5" stop-opacity="0.75"/>' +
      '<stop offset="100%" stop-color="#A8C4E5" stop-opacity="1"/>' +
      '</linearGradient>' +
      '<linearGradient id="oqBadge" x1="0.2" y1="0" x2="0" y2="1">' +
      '<stop offset="0%" stop-color="#6C93C2"/>' +
      '<stop offset="100%" stop-color="#265392"/>' +
      '</linearGradient></defs>' +
      grid + labels +
      '<path class="oq-chart-area" d="' + areaPath + '" fill="url(#oqArea)"/>' +
      ghost +
      '<path class="oq-chart-trace" style="stroke:url(#oqTrace)" d="' + path + '"/>' +
      '<circle class="oq-chart-pin" cx="' + startX + '" cy="' + startY + '" r="9" fill="' + levelColor + '" opacity="0.28"/>' +
      '<circle class="oq-chart-pulse" cx="' + startX + '" cy="' + startY + '" r="8" fill="' + levelColor + '"/>' +
      '<circle class="oq-chart-pin" cx="' + startX + '" cy="' + startY + '" r="7" fill="' + levelColor + '"/>' +
      '<g class="oq-chart-callout oq-chart-callout--end"><rect x="' + badgeX + '" y="' + badgeY + '" rx="' + (badgeH / 2) + '" ry="' + (badgeH / 2) + '" width="' + badgeW + '" height="' + badgeH + '" fill="url(#oqBadge)"/>' +
      '<text x="' + (badgeX + badgeW / 2) + '" y="' + (badgeY + (mob ? 17.5 : 22)) + '" text-anchor="middle" fill="#fff" font-size="18" font-weight="900" font-family="Satoshi Variable, Satoshi, sans-serif">' + esc(r.gain) + '</text></g>' +
      '<circle class="oq-chart-pin oq-chart-pin--end" cx="' + endX + '" cy="' + endY + '" r="7" fill="#fff" stroke="#6C93C2" stroke-width="6"/>' +
      '</svg>' + calloutHtml + '</div>' + legend + '</div>';
  }

  /* ---- screen renderers ------------------------------------ */
  function renderQuestion(sc, index) {
    var html = '';
    var d = 1;
    if (index === 0) {
      var h = QUIZ.hero;
      html += '<h1 class="oq-h1 oq-fade-up oq-d1">' + h.h + '</h1>';
      html += '<p class="oq-sub oq-fade-up oq-d2 oq-pull-24">' + h.sub + '</p>';
      html += '<div class="oq-fade-up oq-d3 oq-pull-16" style="width:100%;display:flex;justify-content:center;">' +
        testimonialCard(h.quote, h.name.charAt(0), h.name) + '</div>';
      html += '<h2 class="oq-h1 oq-qlabel oq-fade-up oq-d4">' + sc.q + '</h2>';
      html += centered(optionsHtml(index, sc.opts), 'oq-fade-up oq-d5 oq-pull-16');
      return html;
    }
    html += '<h1 class="oq-h1 oq-fade-up oq-d' + d + '">' + sc.q + '</h1>'; d++;
    if (sc.sub) { html += '<p class="oq-sub oq-fade-up oq-d' + d + '">' + sc.sub + '</p>'; d++; }
    html += centered(optionsHtml(index, sc.opts), 'oq-fade-up oq-d' + d); d++;
    if (sc.note) { html += '<p class="oq-helper oq-fade-up oq-d' + d + '">' + esc(sc.note) + '</p>'; d++; }
    if (sc.why) { html += centered(whyBox(sc.why), 'oq-fade-up oq-d' + d); }
    return html;
  }

  function renderProof(sc) {
    return '<h1 class="oq-h1 oq-fade-up oq-d1">You are in the right place.</h1>' +
      '<p class="oq-sub oq-fade-up oq-d2 oq-pull-24">' + esc(sc.sub) + '</p>' +
      '<div class="oq-fade-up oq-d3" style="width:100%;display:flex;justify-content:center;"><button type="button" class="oq-cta" data-continue>CONTINUE ' + ARROW_IMG + '</button></div>' +
      '<div class="oq-testimonial-row oq-fade-up oq-d4">' +
      sc.t.map(function (x) { return testimonialCard(x[0], x[1].charAt(0), x[1].toUpperCase()); }).join('') +
      '</div>';
  }

  function renderL1(sc) {
    return '<div class="oq-fade-up oq-d1">' + ringHtml('0%', 'analyzes') + '</div>' +
      '<h1 class="oq-h1 oq-fade-up oq-d2">Analyzing your responses...</h1>' +
      '<p class="oq-sub oq-fade-up oq-d3 oq-pull-32">' + esc(sc.l1) + '</p>' +
      '<div class="oq-dots oq-fade-up oq-d4"><span class="oq-dot is-active"></span><span class="oq-dot"></span><span class="oq-dot"></span></div>';
  }

  function renderL2() {
    return '<h1 class="oq-h1 oq-fade-up oq-d1">Building your profile...</h1>' +
      '<p class="oq-sub oq-fade-up oq-d2 oq-pull-32">' + esc(loaderTitle()) + '</p>' +
      '<div class="oq-steps oq-fade-up oq-d3 oq-pull-16" data-steps></div>' +
      '<div class="oq-step-footer oq-fade-up oq-d4"><span data-step-count>Step 1 of ' + loaderSteps().length + '</span>' +
      '<div class="oq-mini-progress"><div class="oq-mini-progress-fill" data-step-progress style="width:' + (100 / loaderSteps().length) + '%"></div></div></div>';
  }

  function renderResult() {
    var r = result();
    var cls = tierClass();
    var potentialColor = tierName() === 'high' ? accentColor() : '#6C93C2';
    return '<div class="oq-result-head ' + cls + '">' +
      '<span class="oq-badge-pill oq-fade-up oq-d1">' + esc(QUIZ.meter.eyebrow) + '</span>' +
      '<h1 class="oq-h1 oq-fade-up oq-d2">Your Results Are In</h1>' +
      '</div>' +
      '<div class="oq-result-col ' + cls + '">' +
      '<div class="oq-fade-up oq-d3">' + gaugeHtml() + '</div>' +
      '<div class="oq-fade-up oq-d4"><div class="oq-alert oq-tier-accent"><span class="oq-alert-icon"></span><div class="oq-alert-body"><p class="oq-alert-title">' + esc(r.status) + '</p><p class="oq-alert-text">' + r.desc + '</p></div></div></div>' +
      '<div class="oq-stats oq-fade-up oq-d5">' +
      r.st.map(function (x, i) {
        var style = i === 2 ? ' style="color:' + potentialColor + '"' : '';
        var valueCls = i === 2 ? 'oq-stat-value' : 'oq-stat-value oq-tier-accent';
        return '<div class="oq-rescard oq-stat"><span class="oq-stat-label">' + esc(x[0]) + '</span>' +
          '<span class="' + valueCls + '"' + style + '>' + esc(x[1]) + '</span>' +
          '<span class="oq-stat-sub">' + esc(x[2]) + '</span></div>';
      }).join('') +
      '</div>' +
      '<div class="oq-fade-up oq-d6"><div class="oq-rescard oq-means"><h3>What This Means For You</h3><div class="oq-means-body"><p>' + r.intro + '</p><ul>' +
      r.b.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('') +
      '</ul><p>' + r.close + '</p></div></div></div>' +
      '<div class="oq-fade-up oq-d7" style="display:flex;justify-content:center;"><button type="button" class="oq-cta oq-cta--xl" data-continue>' + esc(r.cta) + '</button></div>' +
      FDA_NOTE +
      '</div>';
  }

  function renderProjection() {
    var r = result();
    var pj = QUIZ.proj;
    var cls = tierClass();
    return '<div class="oq-result-head ' + cls + '">' +
      '<span class="oq-badge-pill oq-fade-up oq-d1">' + esc(pj.eyebrow) + '</span>' +
      '<h1 class="oq-h1 oq-fade-up oq-d2">' + esc(pj.title) + '</h1>' +
      '<p class="oq-sub oq-fade-up oq-d3">' + esc(pj.sub) + '</p>' +
      '</div>' +
      '<div class="oq-result-col oq-result-col--r2 ' + cls + '">' +
      '<div class="oq-fade-up oq-d4">' + chartHtml() + '</div>' +
      '<div class="oq-milestones oq-fade-up oq-d5"><h3 class="oq-milestones-title">Expected Milestones</h3>' +
      r.ms.map(function (m, i) {
        var last = i === r.ms.length - 1;
        return '<div class="oq-rescard oq-milestone oq-tier-accent"><div class="oq-ms-iconcol"><span class="oq-ms-dot"></span>' +
          (last ? '' : '<span class="oq-ms-line"></span>') +
          '</div><div class="oq-milestone-body"><h4><span>' + esc(m[0]) + '</span>' + esc(m[1]) + '</h4><p>' + esc(m[2]) + '</p></div></div>';
      }).join('') + '</div>' +
      '<div class="oq-fade-up oq-d6" style="display:flex;justify-content:center;"><button type="button" class="oq-cta" data-continue>GET MY PROTOCOL ' + ARROW_IMG + '</button></div>' +
      FDA_NOTE +
      '</div>';
  }

  function renderFinal() {
    return '<div class="oq-fade-up oq-d1">' + ringHtml('1/' + finalSteps().length, '') + '</div>' +
      '<h1 class="oq-h1 oq-fade-up oq-d2">Building your profile...</h1>' +
      '<p class="oq-sub oq-fade-up oq-d3 oq-pull-32">' + esc(loaderTitle()) + '</p>' +
      '<div class="oq-steps oq-fade-up oq-d4" data-steps></div>' +
      '<div class="oq-fade-up oq-d5"><span class="oq-urgency">' + LIGHTNING_SVG + 'Your discount expires soon</span></div>';
  }

  function renderGate() {
    return '<div class="oq-result-head oq-gate-head">' +
      '<span class="oq-badge-pill oq-fade-up oq-d1">' + esc(GATE.eyebrow) + '</span>' +
      '<h1 class="oq-h1 oq-fade-up oq-d2">' + esc(GATE.h) + '</h1>' +
      '<p class="oq-sub oq-fade-up oq-d3">' + esc(GATE.sub) + '</p>' +
      '</div>' +
      '<form class="oq-gate oq-fade-up oq-d4" data-oq-gate novalidate>' +
      '<div class="oq-gate-preview ' + tierClass() + '" aria-hidden="true">' +
      '<div class="oq-gate-blur">' + gaugeHtml() + '</div>' +
      '<span class="oq-badge-pill oq-gate-lock">' + esc(GATE.lock) + '</span>' +
      '</div>' +
      '<label class="visually-hidden" for="oq-gate-email">Email address</label>' +
      '<input class="oq-gate-input" id="oq-gate-email" type="email" name="email" autocomplete="email" inputmode="email" autocapitalize="off" spellcheck="false" placeholder="' + esc(GATE.placeholder) + '" value="' + esc(gateState.email) + '" required>' +
      '<p class="oq-gate-error" data-gate-error role="alert" hidden></p>' +
      '<button type="submit" class="oq-cta" data-gate-submit>' + esc(GATE.cta) + ' ' + ARROW_IMG + '</button>' +
      '<p class="oq-gate-legal">' + esc(GATE.legal) + ' <a href="' + esc(PRIVACY_URL) + '" target="_blank" rel="noopener">Privacy Policy</a></p>' +
      '</form>';
  }

  function screenHtml(idx) {
    if (gateState.open) return renderGate();
    if (idx === IDX_RESULT) return renderResult();
    if (idx === IDX_PROJECTION) return renderProjection();
    if (idx === IDX_FINAL) return renderFinal();
    var sc = STEPS[idx];
    if (sc.proof) return renderProof(sc);
    if (sc.l1) return renderL1(sc);
    if (sc.l2) return renderL2();
    return renderQuestion(sc, idx);
  }

  /* ---- flow ------------------------------------------------ */
  /* navigation counts questions; no_middle counts only the screens it shows */
  function stepPos(idx) {
    if (variantIs('navigation')) return { pos: QNUM[idx] || 1, total: TOTAL_Q };
    if (!variantIs('no_middle')) return { pos: Math.min(idx + 1, STEPS.length), total: STEPS.length };
    var pos = 0;
    var total = 0;
    for (var i = 0; i < STEPS.length; i++) {
      if (skipsScreen(i)) continue;
      total++;
      if (i <= idx) pos++;
    }
    return { pos: Math.max(1, pos), total: total };
  }

  function progressFor(idx) {
    var p = stepPos(idx);
    return Math.min(100, Math.round((p.pos / p.total) * 100));
  }

  var hasRendered = false;

  function syncA11y(stage, pct) {
    var bar = root.querySelector('.oq-progress');
    var live = root.querySelector('[data-oq-live]');
    var heading = stage.querySelector('h1, h2');
    if (bar) bar.setAttribute('aria-valuenow', String(pct));
    if (live) {
      live.textContent = NO_PROGRESS[state.screen]
        ? (heading ? heading.textContent : '')
        : 'Step ' + stepPos(state.screen).pos + ' of ' + stepPos(state.screen).total;
    }
    if (hasRendered && heading) {
      heading.setAttribute('tabindex', '-1');
      heading.style.outline = 'none';
      heading.focus({ preventScroll: true });
    }
    hasRendered = true;
  }

  function render() {
    var stage = root.querySelector('[data-oq-stage]');
    var fill = root.querySelector('[data-oq-progress]');
    var header = root.querySelector('.oq-header');
    stage.innerHTML = screenHtml(state.screen);
    stage.setAttribute('data-screen', String(state.screen));
    if (header) header.classList.toggle('no-progress', !!NO_PROGRESS[state.screen]);
    syncNav();
    var pct = progressFor(state.screen);
    if (fill) fill.style.width = pct + '%';
    syncA11y(stage, pct);
    window.scrollTo(0, 0);
    var stepNow = Date.now();
    if (state.screen === 0) lastStepAt = null;
    var stepParams = {
      step_index: state.screen,
      step_id: gateState.open ? 'email_gate' : SCREEN_IDS[state.screen] || 'screen_' + state.screen
    };
    if (lastStepAt !== null) stepParams.step_ms = Math.round(stepNow - lastStepAt);
    lastStepAt = stepNow;
    track('quiz_step_viewed', stepParams);
    if (gateState.open) return;
    var sc = STEPS[state.screen];
    if (sc && sc.l1) runAnalyzeLoader();
    if (sc && sc.l2) runBuildSteps();
    if (state.screen === IDX_FINAL) runFinalSteps();
    if (state.screen === IDX_RESULT) track('quiz_result_viewed', { tier: tierName(), level: result().level, score: state.score });
  }

  function goTo(idx) {
    while (skipsScreen(idx)) {
      if (STEPS[idx].l2) completeQuiz();
      idx++;
    }
    if (variantIs('no_middle') && idx >= IDX_RESULT) {
      leaveForPdp();
      return;
    }
    state.screen = Math.min(idx, TOTAL - 1);
    render();
  }

  function runAnalyzeLoader() {
    var ring = root.querySelector('[data-ring]');
    var value = root.querySelector('[data-ring-value]');
    var dots = root.querySelectorAll('.oq-dot');
    if (!ring || !value) return;
    var c = 2 * Math.PI * RING_R;
    var start = null;
    var DURATION = 4000;
    function frame(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / DURATION);
      value.innerHTML = ringValueHtml(Math.round(p * 100) + '%');
      ring.style.strokeDashoffset = c * (1 - p);
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i <= Math.floor(p * 2.99));
      });
      if (p < 1) requestAnimationFrame(frame);
      else setTimeout(function () { goTo(state.screen + 1); }, 400);
    }
    requestAnimationFrame(frame);
  }

  function runStepSequence(stepsDef, opts, onDone) {
    var container = root.querySelector('[data-steps]');
    if (!container) return;
    var total = stepsDef.length;
    var idx = opts.startAt || 0;
    function paint() {
      container.innerHTML = stepsDef.map(function (s, i) {
        return stepCard(s, i < idx ? 'done' : i === idx ? 'active' : 'pending', opts.ring);
      }).join('');
      container.querySelectorAll('.oq-step').forEach(function (el, i) {
        if (i < idx) el.classList.add('is-done');
        if (i === idx) el.classList.add('is-active');
      });
      if (opts.counter) {
        var cnt = root.querySelector('[data-step-count]');
        var prog = root.querySelector('[data-step-progress]');
        if (cnt) cnt.textContent = 'Step ' + Math.min(idx + 1, total) + ' of ' + total;
        if (prog) prog.style.width = (Math.min(idx + 1, total) / total) * 100 + '%';
      }
      if (opts.ring) {
        var value = root.querySelector('[data-ring-value]');
        var ring = root.querySelector('[data-ring]');
        if (value) value.textContent = Math.min(idx + 1, total) + '/' + total;
        if (ring) {
          var c = 2 * Math.PI * RING_R;
          ring.style.strokeDashoffset = c * (1 - Math.min(idx + 1, total) / total);
          ring.style.transition = 'stroke-dashoffset 600ms ease';
        }
      }
    }
    paint();
    var timer = setInterval(function () {
      idx++;
      if (opts.onPause && idx === opts.pauseAt) {
        clearInterval(timer);
        paint();
        setTimeout(opts.onPause, 450);
        return;
      }
      if (idx >= total) {
        clearInterval(timer);
        paint();
        setTimeout(onDone, 600);
        return;
      }
      paint();
    }, 1500);
  }

  function completeQuiz() {
    if (completed) return;
    completed = true;
    if (!state.forcedTier) calcScore();
    track('quiz_completed', {
      total_score: state.score, max_score: QUIZ.max, tier: tierName(),
      result: 'R' + (state.tier + 1), level: result().level, display_pct: displayPct()
    });
    /* email_gate already sent the "Completed" event with the email */
    if (!variantIs('email_gate')) sendToKlaviyo();
  }

  function runBuildSteps() {
    var opts = { counter: true };
    /* email_gate: the loader stops on its last step ("Personalizing your result") and
       swaps to the gate; after submit it re-renders from that step into results */
    if (variantIs('email_gate')) {
      var last = loaderSteps().length - 1;
      opts.startAt = gateState.resumeStep;
      if (!gateState.email) {
        opts.pauseAt = last;
        opts.onPause = function () {
          if (!state.forcedTier) calcScore();
          gateState.open = true;
          gateState.resumeStep = last;
          render();
        };
      }
    }
    runStepSequence(loaderSteps(), opts, function () {
      completeQuiz();
      goTo(state.screen + 1);
    });
  }

  function isValidEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
  }

  function submitGate(form) {
    var input = form.querySelector('.oq-gate-input');
    var error = form.querySelector('[data-gate-error]');
    var btn = form.querySelector('[data-gate-submit]');
    var email = (input.value || '').trim();
    if (!isValidEmail(email)) {
      input.classList.add('is-error');
      error.textContent = GATE.invalid;
      error.hidden = false;
      input.focus();
      track('quiz_email_invalid', {});
      return;
    }
    input.classList.remove('is-error');
    error.hidden = true;
    btn.disabled = true;
    btn.classList.add('is-loading');
    gateState.email = email;
    track('quiz_email_submitted', { tier: tierName() });
    /* requests keep running in the background - don't make a slow API hold the user */
    Promise.race([sendGateToKlaviyo(email), new Promise(function (r) { setTimeout(r, 4000); })]).then(function () {
      gateState.open = false;
      render();
    });
  }

  /* variant: no results/projection/final loader. The short wait lets the
     quiz_completed / quiz_redirect / Klaviyo calls go out before the page unloads. */
  function leaveForPdp() {
    if (leaving) return;
    leaving = true;
    completeQuiz();
    track('quiz_redirect', { tier: tierName(), url: REDIRECT_URL });
    setTimeout(function () { window.location.href = REDIRECT_URL; }, 800);
  }

  function runFinalSteps() {
    var url = REDIRECT_URL;
    track('quiz_redirect', { tier: tierName(), url: url });
    runStepSequence(finalSteps(), { ring: true }, function () {
      window.location.href = url;
    });
  }

  root.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-oq-gate]');
    if (!form) return;
    e.preventDefault();
    if (!form.querySelector('[data-gate-submit]').disabled) submitGate(form);
  });

  root.addEventListener('input', function (e) {
    if (!e.target.classList.contains('oq-gate-input') || !e.target.classList.contains('is-error')) return;
    e.target.classList.remove('is-error');
    var error = root.querySelector('[data-gate-error]');
    if (error) error.hidden = true;
  });

  root.addEventListener('click', function (e) {
    var back = e.target.closest('[data-oq-back]');
    if (back) {
      if (back.classList.contains('is-hidden')) return;
      clearTimeout(advanceTimer);
      goTo(prevScreen(state.screen));
      return;
    }
    var opt = e.target.closest('.oq-option');
    if (opt && !opt.disabled) {
      var s = parseInt(opt.getAttribute('data-s'), 10);
      var i = parseInt(opt.getAttribute('data-i'), 10);
      if (!state.started) {
        state.started = true;
        track('quiz_started', {});
        startQuizTest();
      }
      state.answers[s] = i;
      state.answerText[s] = opt.textContent.trim();
      calcScore();
      var qp = { question_id: QUESTION_KEYS[s] || 'screen_' + s, answer_index: i };
      if (STEPS[s].key) qp.question_key = STEPS[s].key;   /* legacy GA param */
      track('quiz_question_answered', qp);
      root.querySelectorAll('.oq-option').forEach(function (b) { b.disabled = true; });
      opt.classList.add('is-selected');
      advanceTimer = setTimeout(function () { goTo(state.screen + 1); }, ADVANCE_DELAY);
      return;
    }
    var cont = e.target.closest('[data-continue]');
    if (cont) {
      track('quiz_cta_clicked', { screen: state.screen, tier: tierName() });
      goTo(state.screen + 1);
    }
  });

  /* Pick this visitor's test among the ones active in Intelligems. Layout tests are
     decided before the quiz is shown (hidden for up to SL_WAIT_MS while one could
     be picked); the rest wait for the first answer. */
  if (!armPreview && typeof window.omniRolloutExpose === 'function') {
    rolloutArm = window.omniRolloutExpose(window.location.pathname.split('/').filter(Boolean).pop() || '');
    if (rolloutArm) {
      quizArm = rolloutArm === 'treatment' ? 'variant' : 'control';
      quizFeature = 'email_gate';
      quizKey = 'rollout';
    }
  }

  if (window.omniQuizTest && !armPreview && !rolloutArm) {
    var reveal = function () { root.style.visibility = ''; };
    if (window.omniQuizTest.hasFeature(root, LOAD_FEATURES)) {
      root.style.visibility = 'hidden';
      setTimeout(reveal, SL_WAIT_MS);
    }
    window.omniQuizTest.choose(root).then(function (test) {
      slTest = test;
      if (test && LOAD_FEATURES[test.feature]) {
        startQuizTest(reveal);
        return;
      }
      reveal();
      if (state.started) startQuizTest();
    });
  }

  render();
})();
